import { defineMessages } from "react-intl";
import {
	colitisUlcerosaIsActiveMessages,
	colitisUlcerosaMessages,
	crohnDiseaseIsActiveMessages,
	crohnDiseaseMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/colonoscopia";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	colonoscopia: {
		id: "form.colonoscopia",
		defaultMessage: "Colonoscopia"
	},
	colitisUlcerosa: {
		id: "form.colonoscopia.colitis_ulcerosa",
		defaultMessage: "Colitis ulcerosa"
	},
	colitisUlcerosaIsActive: {
		id: "form.colonoscopia.colitis_ulcerosa_is_active",
		defaultMessage: "Colitis ulcerosa aktivitás"
	},
	crohnDisease: {
		id: "form.colonoscopia.crohn_disease",
		defaultMessage: "Crohn-betegség"
	},
	crohnDiseaseIsActive: {
		id: "form.colonoscopia.crohn_disease_is_active",
		defaultMessage: "Crohn-betegség aktivitás"
	},
	comment: {
		id: "form.colonoscopia.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	colitisUlcerosa: {
		type: "field",
		path: ["colitisUlcerosa"],
		label: messages.colitisUlcerosa,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: colitisUlcerosaMessages }
		}
	},
	colitisUlcerosaIsActive: {
		type: "field",
		path: ["colitisUlcerosaIsActive"],
		label: messages.colitisUlcerosaIsActive,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: colitisUlcerosaIsActiveMessages }
		}
	},
	crohnDisease: {
		type: "field",
		path: ["crohnDisease"],
		label: messages.crohnDisease,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: crohnDiseaseMessages } }
	},
	crohnDiseaseIsActive: {
		type: "field",
		path: ["crohnDiseaseIsActive"],
		label: messages.crohnDiseaseIsActive,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: crohnDiseaseIsActiveMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.colitisUlcerosa }] },
		{ columns: [{ width: 12, field: fields.colitisUlcerosaIsActive }] },
		{ columns: [{ width: 12, field: fields.crohnDisease }] },
		{ columns: [{ width: 12, field: fields.crohnDiseaseIsActive }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "colonoscopia",
	value: {
		title: messages.colonoscopia,
		validator,
		fieldset,
		isImportant: true
	}
};
